const DEMOCRAT = [
  '#1755c5',
  '#ffc200',
  '#91dfe5',
  '#fcbec3',
  '#5acc7d',
  '#182b4b',
];


const OTHER = '#888888'

const NEUTRAL = '#F2F2F2';
const TIE = '#999999';

export { DEMOCRAT, NEUTRAL, TIE, OTHER };
